import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import logo from './logo-final.svg';
import { NavLink } from 'react-router-dom';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { LoadingScreen } from '../Layout/LoadingScreen';
import { emailValidation } from '../action/login2fa/emailValidation';

export const Emailverify = () => {
  const dispatch = useDispatch();
  const { isLoadingActive } = useSelector(state => state.uiState);
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const email = params.get('email');

  const isValid = () => {
    let isValid = true;
    if (!token || !email || params.size < 1) {
      isValid = false;
    }
    return isValid;
  }

  const submit = () => {
    if (isValid()) {
      dispatch(UIActions.uiLoadActive());
      dispatch(emailValidation(email, token, dispatch));
    } else {
      window.location.replace("/login");
    }
  }

  useEffect(() => {
    const submitCallback = () => {
      submit();
    };

    submitCallback();
  }, []);


  return (
    <>
      {
        (isLoadingActive)
        &&
        <LoadingScreen />
      }
      <div className="justify-content-center align-items-center d-flex flex-column body-gradient"
        style={{ top: '0px', bottom: '0px', left: '0px', right: '0px', position: 'fixed' }}>
        <div className="miclase col-lg-4 col-md-6 col-sm-12 bg-white shadow p-3">
          <div className="row justify-content-center p-3">
            <img style={{ width: `12rem` }} src={logo} alt="logo redsmart" />
          </div>
          <div className="login-pdv text-center justify-content-center">
            <h2>Validando email</h2>
          </div>
          <div className='text-center'>
            <NavLink to="/login">
              <button className='btn'>Regresar a Login</button>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  )
}